module.exports = "/fonts/fa-solid-900.woff2?9ef50a04ef2ee9703d694b2244abd928";